import React from 'react';
import { useIntl } from 'react-intl';
import { IndicatorContainerProps } from 'react-select';

import { Option } from '../../../types/Option';
import { IconButton } from '../../IconButton/IconButton';
import { Layout } from '../../Layout/Layout';

export const IndicatorsContainer = (
  props: IndicatorContainerProps<Option, boolean>,
) => {
  const { children, hasValue, clearValue, selectProps } = props;
  const { name, inputValue, isClearable, isDisabled } = selectProps;
  const shouldClearValue =
    !isDisabled && isClearable && (hasValue || inputValue);
  const intl = useIntl();

  return (
    <Layout preset="icons">
      {shouldClearValue && (
        <IconButton
          preset="clear-all"
          text={intl.formatMessage(
            {
              id: 'IndicatorsContainer.clearAll',
              defaultMessage: 'clear all {name}',
              description:
                'Button label to clear all selected values in select input. Example: name = "values"',
            },
            {
              name,
            },
          )}
          onClick={clearValue}
        />
      )}
      {children}
    </Layout>
  );
};
